import GameEvents from "../../core/src/const/GameEvents";
import { IWinData } from "../../core/src/server/data/ISpinData";
import ReelGroup from "../../core/src/views/ReelGroup";
import WinlinesView from "../../core/src/views/WinlinesView";

export default class VendorReelGroup extends ReelGroup {

    protected isSummaryWin: boolean;
    protected winGroupToAnimVendor: number;

    constructor() {
        super();
    }

    protected playAnimsOnce(winlinesToShow: IWinData[]) {
        this.isSummaryWin = true;
        winlinesToShow.forEach((winline) => {
            this.highlightWinlineWin(winline, false);
            // Uncomment the next line if you wish to show the winlines over the reel.
            // this.winlinesView.highlightWinLine(winline, false);
        });
    }

    public showWinLines(winlinesToShow: IWinData[], repeat = -1, showBaners = false) {
        this.isSummaryWin = false;
        this.winGroupToAnimVendor = 0;
        let competed = false;
        this.off(GameEvents.GROUP_ANIM_COMPLETE);
        this.on(GameEvents.GROUP_ANIM_COMPLETE, () => {
            let lastId = this.winGroupToAnimVendor;
            this.winGroupToAnimVendor += 1;
            if (this.winGroupToAnimVendor > winlinesToShow.length - 1) {
                this.winGroupToAnimVendor = 0;
                this.emit(GameEvents.WIN_ANIMATIONS_COMPLETE);
                competed = true;
                if (repeat > 0) {
                    repeat--;
                }

                if (repeat === 0) {
                    this.off(GameEvents.GROUP_ANIM_COMPLETE);

                }
            }
            if (!competed || repeat !== 0) {
                this.hideWinlineWin(winlinesToShow[lastId]);
                const winline = winlinesToShow[this.winGroupToAnimVendor];
                
                this.highlightWinlineWin(winline, showBaners);
                (this.winlinesView as WinlinesView).highlightWinLine(winline, true);
            }
        });
        const winlineData = winlinesToShow[this.winGroupToAnimVendor];
        this.highlightWinlineWin(winlineData, showBaners);
        (this.winlinesView as WinlinesView).highlightWinLine(winlineData, true);
    }

    public showWaysGroups(winsData, showBanner = false) {
        this.winGroupToAnimVendor = 0;
        this.on(GameEvents.GROUP_ANIM_COMPLETE, () => {
            this.winGroupToAnimVendor += 1;
            if (this.winGroupToAnimVendor > winsData.length - 1) {
                this.winGroupToAnimVendor = 0;
            }
            this.animateWaysGroup(winsData[this.winGroupToAnimVendor].coordinates);
            this.winSymbolsView.getChildren().sort(this.symCompare.bind(this));
            if (showBanner) {
                this.winlinesView.setWinBannerValue(
                    winsData[this.winGroupToAnimVendor].creditsWon
                );
            }
        });
        this.animateWaysGroup(winsData[this.winGroupToAnimVendor].coordinates);
        if (showBanner) {
            this.winlinesView.setWinBannerValue(
                winsData[this.winGroupToAnimVendor].creditsWon
            );
        }
        this.winSymbolsView.getChildren().sort(this.symCompare.bind(this));
    }
}